<template>
  <main class="customer_join main" id="join_main">
    <div class="join_inner">
      <div class="text_area">
        <h2>우리 동네를<br />설정해 주세요!</h2>
        <p>우리 동네 기반으로 상품과 매장을 안내드려요!</p>
      </div>
      <div class="area_setting_result" v-if="areaInfo.areaId">
        <p>{{ areaInfo.areaFullName }}</p>
        <!-- <button>
          <img src="@/assets/front/images/v2/icons/ic_x_input.svg" />
        </button> -->
      </div>
      <div class="input_area">
        <div class="input input_txt input_srch">
          <input
            type="text"
            v-model="searchText"
            placeholder="동, 읍, 면 단위로 검색"
            @keyup.enter="getRegionByName"
          />
          <button class="btn_srch" @click="getRegionByName"></button>
        </div>
      </div>
      <div class="area_setting">
        <div class="area_sec spot">
          <button class="current_location" @click="getCurrentRegion">
            현재 위치 불러오기
          </button>
        </div>
        <div v-show="showCurrentRegion">
          <div v-if="myArea.nearby.length">
            <div class="area_sec">
              <dl>
                <dt>우리동네</dt>
                <dd @click="selectRegion(myArea.current, fromPage)">
                  {{ myArea.current.name }}
                </dd>
              </dl>
            </div>
            <div class="area_sec">
              <dl>
                <dt>근처동네</dt>
                <dd
                  v-for="(item, index) in myArea.nearby"
                  v-bind:key="index"
                  @click="selectRegion(item, fromPage)"
                >
                  {{ item.name }}
                </dd>
              </dl>
            </div>
          </div>
          <div class="no_reasult" v-if="myArea.nearby.length == 0">
            <img
              src="@/assets/front/images/v2/character/img_empty_result.png"
            />
            <p>
              현재 위치로 정보를 받아오지 못했습니다.<br />우리동네 이름으로
              검색해보세요.
            </p>
          </div>
        </div>
        <div v-show="showSearchResult">
          <div v-if="area.count">
            <div class="area_sec">
              <dl>
                <dt>검색결과</dt>
                <dd
                  v-for="(item, index) in area.content"
                  v-bind:key="index"
                  @click="selectRegion(item, fromPage)"
                >
                  {{ item.name }}
                </dd>
              </dl>
            </div>
          </div>
          <div class="no_reasult" v-if="area.count == 0">
            <img
              src="@/assets/front/images/v2/character/img_empty_result.png"
            />
            <p>검색하신 동네가 없습니다.<br />검색어를 확인해 주세요!</p>
          </div>
        </div>
      </div>
    </div>
    <div class="join_btn_area area_btn">
      <button :disabled="isDisabled" @click="goJoinNickname()">
        가입 완료
      </button>
    </div>
    <GPSUseConfirmModal
      v-if="gpsUseModal"
      @close="hideGpsUseModal"
      @setting="openSetting"
    ></GPSUseConfirmModal>
    <GPSOffModal
      v-if="gpsOffModal"
      @close="hideGpsOffModal"
      @setting="openSetting"
    ></GPSOffModal>
  </main>
</template>
<script>
import {
  isApp,
  sleep,
  clearLocation,
  nativeLocation,
  nativeGoToSetting,
  nativeEnableBackKey,
  nativeDisableBackKey,
  nativeDeviceInfo,
} from '@common/lib/common/utils';

import GPSUseConfirmModal from '@/front/customer/views/auth/modal/GPSUseConfirmModal';
import GPSOffModal from '@/front/customer/views/auth/modal/GPSOffModal';
import { mapActions, mapState, mapGetters } from '@common/store/modules/area';
import * as actions from '@common/store/modules/area/types';
import * as getters from '@common/store/modules/area/getters';

export default {
  name: 'JoinRegion',
  components: { GPSOffModal, GPSUseConfirmModal },
  data() {
    return {
      isFirst: true,
      gpsUseModal: false,
      gpsOffModal: false,
      checkerId: -1,
      latitude: 0,
      longitude: 0,

      fromPage: 'Auth',
      lat: 0,
      lng: 0,
      searchText: '',
      showSearchResult: false,
      showCurrentRegion: false,
      geolocationAvailable: false,
      areaInfo: {
        areaId: '',
        areaName: '',
        areaFullName: '',
        codeType: '',
      },
      isDisabled: true,
    };
  },
  async created() {
    await this.handleLocation();
    await this.handleRefresh();
  },
  async mounted() {},
  computed: {
    ...mapGetters({
      myArea: getters.MY_AREA,
      area: getters.AREA,
    }),
  },
  methods: {
    ...mapActions([
      actions.FETCH_CURRENT,
      actions.FETCH_DONG,
      actions.AREA_RESET_STATE,
    ]),
    startChecker() {
      if (this.checkerId === -1) {
        this.checkerId = setInterval(() => {
          if (window.$bridge.location.code === '1') {
            this.hideGpsOffModal();
            this.hideGpsUseModal();
          }
        }, 1000);
      }
    },
    hideGpsUseModal() {
      this.gpsUseModal = false;
      if (this.checkerId !== -1) {
        clearInterval(this.checkerId);
        this.checkerId = -1;
      }
    },
    hideGpsOffModal() {
      this.gpsOffModal = false;
      if (this.checkerId !== -1) {
        clearInterval(this.checkerId);
        this.checkerId = -1;
      }
    },
    showGpsUseModal() {
      this.gpsUseModal = true;
      if (this.checkerId === -1) {
        this.startChecker();
      }
    },
    showGpsOffModal() {
      this.gpsOffModal = true;
      if (this.checkerId === -1) {
        this.startChecker();
      }
    },
    openSetting() {
      if (!isApp()) {
        this.getLocation();
      } else {
        // 네이티브 앱 위치설정 열기
        nativeGoToSetting(2);
      }
    },
    // 위치정보 확인 후 동네설정으로 이동
    gotoRegionSetting() {
      this.handleLocation();
    },
    async handleLocation() {
      // 앱이 아닌 경우
      if (!isApp()) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then(permissionStatus => {
            console.log(permissionStatus.state.toString());

            switch (permissionStatus.state.toString()) {
              case 'prompt':
                if (!this.isFirst) this.showGpsUseModal();
                break;
              case 'denied':
                if (!this.isFirst) this.showGpsOffModal();
                break;
              //   case 'granted':
              //     if (!this.isFirst) this.$router.push({ name: 'Auth.Region' });
              //     break;
              //   default:
              //     //this.$router.push({ name: 'Auth.Region' });
              //     break;
            }

            this.isFirst = false;
          });
      }
      // 앱인 경우
      else {
        clearLocation();
        nativeLocation();
        await sleep(1000);
        if (window.$bridge.location.code !== undefined) {
          // GPS 켜져있을때 : 1, 꺼져있을 때 -1
          if (window.$bridge.location.code === '1') {
            this.hideGpsOffModal();
            this.hideGpsUseModal();
            if (!this.isFirst) await this.$router.push({ name: 'Auth.Region' });
          } else {
            this.showGpsOffModal();
          }
          this.isFirst = false;
        } else {
          if (!this.isFirst) this.showGpsUseModal();
          this.isFirst = false;
        }
      }
    },

    getLocation() {
      if (navigator.geolocation) {
        return new Promise(() => {
          navigator.geolocation.getCurrentPosition(
            this.showPosition,
            this.showError,
          );
        });
      } else {
        console.log('Geolocation is not supported by this browser.');
      }
    },

    showPosition(position) {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
    },

    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.log('User denied the request for Geolocation.');
          break;
        case error.POSITION_UNAVAILABLE:
          console.log('Location information is unavailable.');
          break;
        case error.TIMEOUT:
          console.log('The request to get user location timed out.');
          break;
        case error.UNKNOWN_ERROR:
          console.log('An unknown error occurred.');
          break;
      }
    },
    async getRegionByName() {
      this.showSearchResult = false;
      await this[actions.AREA_RESET_STATE]();

      const param = {
        keyword: this.searchText,
      };
      if (param.keyword) {
        await this[actions.FETCH_DONG](param);
      }
      this.showCurrentRegion = false;
      this.showSearchResult = true;
    },
    selectRegion(area, fromPage) {
      const { id, name, emd_name, codeType } = area;

      console.log('areaareaarea');
      console.log(area);

      this.areaInfo.areaId = id;
      this.areaInfo.areaName = emd_name;
      this.areaInfo.areaFullName = name;
      this.areaInfo.codeType = codeType;

      this.isDisabled = false;

      const target = document.querySelector('#join_main');
      setTimeout(() => {
        target.scrollTo(0, 0);
      }, 10);
    },
    async getCurrentRegion() {
      await this.handleRefresh();
      if (this.geolocationAvailable) {
        this.showSearchResult = false;
        this.showCurrentRegion = false;
        this[actions.AREA_RESET_STATE]();
        const param = {
          distance: 2000,
          latitude: this.lat,
          longitude: this.lng,
        };
        await this[actions.FETCH_CURRENT](param);
        this.showCurrentRegion = true;
      } else {
        this.showSearchResult = false;
        this.showCurrentRegion = true;
      }
    },
    async handleRefresh() {
      if (!isApp()) {
        if (this.$geolocation.checkSupport()) {
          try {
            const currentPosition = await this.$geolocation.getCurrentPosition();

            if (currentPosition) {
              console.log(currentPosition);
              this.lat = currentPosition.coords.latitude;
              this.lng = currentPosition.coords.longitude;
              this.geolocationAvailable = true;
            }
          } catch (err) {
            this.myArea.nearby.length = 0;
            this.geolocationAvailable = false;
          }
        }
      } else {
        clearLocation();
        nativeLocation();
        await sleep(1000);
        //alert('location.code: ' + window.$bridge.location.code);
        if (window.$bridge.location.code !== undefined) {
          // GPS 켜져있을때 : 1, 꺼져있을 때 -1
          if (window.$bridge.location.code === '1') {
            //alert('a1');
            this.hideGpsOffModal();
            this.hideGpsUseModal();
            this.lat = window.$bridge.location.latitude;
            this.lng = window.$bridge.location.longitude;
            this.geolocationAvailable = true;
          } else {
            this.showGpsOffModal();
          }
        } else {
          this.showGpsUseModal();
        }
      }
    },
    goJoinNickname() {
      if (this.areaInfo.areaId === '') {
        alert('우리동네를 선택해 주세요.');
        return false;
      }

      localStorage.setItem('join_region', JSON.stringify(this.areaInfo));

      this.$router.push({
        name: 'Auth.JoinNickname',
      });
    },
  },
};
</script>
